import { isLocal, API_BASE_URL } from "./env";

// Re-export isLocal for backward compatibility
export { isLocal } from "./env";

// logger.log('Is Local:', isLocal);
// logger.log('API Base URL being used:', API_BASE_URL);

export const API_ENDPOINTS = {
  maintenanceStatus: `${API_BASE_URL}/api/maintenance/`,

  // User management
  user: `${API_BASE_URL}/api/user/`,
  register: `${API_BASE_URL}/api/register/`,
  forgotPassword: `${API_BASE_URL}/api/forgotpwd/`,
  login: `${API_BASE_URL}/api/login/`,
  logout: `${API_BASE_URL}/api/logout/`,
  resetPassword: `${API_BASE_URL}/api/resetpwd/`,
  updateProfile: `${API_BASE_URL}/api/updateprofile/`,
  verifyEmail: `${API_BASE_URL}/api/verify-email/`,
  resendVerificationEmail: `${API_BASE_URL}/api/resend-verification-email/`,
  isUsernameAvailable: `${API_BASE_URL}/api/user-available/`,
  deleteAccount: `${API_BASE_URL}/api/delete-account/`,
  
  // Subscriptions
  subscribe: `${API_BASE_URL}/api/subscribe/`,
  publicSubscribe: `${API_BASE_URL}/api/public/subscribe/`,
  completePublicOnboarding: `${API_BASE_URL}/api/public/onboarding/complete/`,
  freeSubscribe: `${API_BASE_URL}/api/free-subscription/`,
  cancelSubscription: `${API_BASE_URL}/api/cancel-subscription/`,
  updateSubscription: `${API_BASE_URL}/api/update-subscription/`,
  reactivateSubscription: `${API_BASE_URL}/api/reactivate-subscription/`,
  syncWithStripe: `${API_BASE_URL}/api/sync-with-stripe/`,
  paymentMethods: `${API_BASE_URL}/api/payment-methods/`,
  addPaymentMethod: `${API_BASE_URL}/api/payment-methods/add/`,
  removePaymentMethod: `${API_BASE_URL}/api/payment-methods/remove/`,
  setDefaultPaymentMethod: `${API_BASE_URL}/api/payment-methods/set-default/`,
  paymentSetupIntent: `${API_BASE_URL}/api/payment-methods/setup-intent/`,

  // Fleet planning
  getProcessedRoutes: `${API_BASE_URL}/api/getprocessedroutes/`,
  getRawRoute: `${API_BASE_URL}/api/getrawroute/`,
  getBatchRawRoutes: `${API_BASE_URL}/api/getbatchrawroutes/`,
  getAllRawRoutes: `${API_BASE_URL}/api/getallrawroutes/`,
  addRoute: `${API_BASE_URL}/api/addroute/`,
  addRoutesBatch: `${API_BASE_URL}/api/addroutesbatch/`,
  deleteRoute: `${API_BASE_URL}/api/deleteroutes/`,
  routeOperatingDays: `${API_BASE_URL}/api/routes/operating-days/`,
  routeDeleteImpact: `${API_BASE_URL}/api/route-delete-impact/`,
  editRoute: `${API_BASE_URL}/api/editroute/`,
  uploadRoutes: `${API_BASE_URL}/api/uploadroutes/`,

  addDepot: `${API_BASE_URL}/api/adddepot/`,
  editDepot: `${API_BASE_URL}/api/editdepot/`,
  getDepot: `${API_BASE_URL}/api/getdepot/`,
  getAllDepots: `${API_BASE_URL}/api/getalldepots/`,
  deleteDepot: `${API_BASE_URL}/api/deletedepots/`,
  fleetDepotCircuitStaleness: `${API_BASE_URL}/api/fleet/depots/circuit-staleness/`,
  fleetDepotRefreshCircuits: `${API_BASE_URL}/api/fleet/depots/refresh-circuits/`,

  getCircuits: `${API_BASE_URL}/api/getcircuits/`,

  getAllChargingStations: `${API_BASE_URL}/api/getallchargingstations/`,
  
  // Vehicle (datahub API)
  getVehicleData: `${API_BASE_URL}/api/get-vehicle-data/`,
  addVehicle: `${API_BASE_URL}/api/add-vehicle/`,
  deleteVehicle: `${API_BASE_URL}/api/delete-vehicle/`,

  getAllFleet: `${API_BASE_URL}/api/getallfleet/`,
  addFleet: `${API_BASE_URL}/api/addfleet/`,
  
  optimize: `${API_BASE_URL}/api/optimize/`,
  optimizeRunsCreate: `${API_BASE_URL}/api/optimize-runs/`,
  optimizeRunsStatus: `${API_BASE_URL}/api/optimize-runs/status/`,
  optimizeRunsCancel: `${API_BASE_URL}/api/optimize-runs/cancel/`,
  optimizeRunsQueue: `${API_BASE_URL}/api/optimize-runs/queue/`,
  optimizeRunsReorder: `${API_BASE_URL}/api/optimize-runs/reorder/`,
  optimizeRunsRemove: `${API_BASE_URL}/api/optimize-runs/remove/`,
  getLatestOptimization: `${API_BASE_URL}/api/getlatestoptimization/`,
  getAllOptimizations: `${API_BASE_URL}/api/getalloptimizations/`,
  getOptimization: `${API_BASE_URL}/api/getoptimization/`,
  deleteOptimization: `${API_BASE_URL}/api/deleteoptimization/`,
  batchDeleteOptimizations: `${API_BASE_URL}/api/batchdeleteoptimizations/`,
  fleetLatestDraft: `${API_BASE_URL}/api/fleet/drafts/latest/`,
  fleetSaveDraft: `${API_BASE_URL}/api/fleet/drafts/`,
  fleetDraftDetail: (draftId) => `${API_BASE_URL}/api/fleet/drafts/${draftId}/`,
  fleetLatestIncompleteCase: `${API_BASE_URL}/api/fleet/cases/incomplete/latest/`,
  fleetSaveIncompleteCase: `${API_BASE_URL}/api/fleet/cases/incomplete/`,
  fleetIncompleteCaseDetail: (caseId) => `${API_BASE_URL}/api/fleet/cases/incomplete/${caseId}/`,
  fleetCaseSummaryList: `${API_BASE_URL}/api/fleet/cases/summary/`,
  fleetDuplicateCase: (caseId) => `${API_BASE_URL}/api/fleet/cases/${caseId}/duplicate/`,
  fleetCaseDetail: (caseId) => `${API_BASE_URL}/api/fleet/cases/${caseId}/`,
  fleetCaseInput: (caseId) => `${API_BASE_URL}/api/fleet/cases/${caseId}/input/`,
  fleetCaseAsk: (caseId) => `${API_BASE_URL}/api/fleet/cases/${caseId}/ask/`,
  fleetCaseAiReport: (caseId) => `${API_BASE_URL}/api/fleet/cases/${caseId}/ai-report/`,
  fleetCaseCompareAsk: `${API_BASE_URL}/api/fleet/cases/compare/ask/`,
  fleetCaseCompareAiReport: `${API_BASE_URL}/api/fleet/cases/compare/ai-report/`,
  fleetAdvisorThreads: `${API_BASE_URL}/api/fleet/advisor/threads/`,
  fleetAdvisorThreadDetail: (threadId) => `${API_BASE_URL}/api/fleet/advisor/threads/${threadId}/`,
  fleetAdvisorThreadMessages: (threadId) => `${API_BASE_URL}/api/fleet/advisor/threads/${threadId}/messages/`,
  fleetAdvisorQuery: `${API_BASE_URL}/api/fleet/advisor/query/`,
  fleetDepotUtilityRatesResolve: `${API_BASE_URL}/api/fleet/depot-utility-rates/resolve/`,
  internalFleetPreviewFleets: `${API_BASE_URL}/api/internal/fleet-preview/fleets/`,
  internalFleetPreviewDates: `${API_BASE_URL}/api/internal/fleet-preview/dates/`,
  internalFleetPreviewDetail: `${API_BASE_URL}/api/internal/fleet-preview/`,
  internalFleetPreviewStops: `${API_BASE_URL}/api/internal/fleet-preview/stops/`,
  internalFleetPreviewRoutedPaths: `${API_BASE_URL}/api/internal/fleet-preview/routed-paths/`,
  internalFleetPreviewVehicleOptions: `${API_BASE_URL}/api/internal/fleet-preview/vehicle-options/`,
  internalFleetPreviewBatchCreate: `${API_BASE_URL}/api/internal/fleet-preview/batch-create/`,
  internalFleetPreviewBatchStatus: `${API_BASE_URL}/api/internal/fleet-preview/batch-status/`,
  internalFleetPreviewBatchCancel: `${API_BASE_URL}/api/internal/fleet-preview/batch-cancel/`,
  
  // ACT Registration
  getEmailCode: `${API_BASE_URL}/api/free-trial-email-code/`,
  validateFreeTrialToken: `${API_BASE_URL}/api/free-trial-token-validation/`,
  testRegister: `${API_BASE_URL}/api/test-registration/`,
  verifyCode: `${API_BASE_URL}/api/free-trial-code-verification/`,
  registerFreeTrial: `${API_BASE_URL}/api/free-trial-registration/`,
  resendVerificationCode: `${API_BASE_URL}/api/resend-verification-code/`,

  // Contact
  contact: `${API_BASE_URL}/api/contact-us/`,
  
  // Utility Rates
  getUtilityRates: `${API_BASE_URL}/api/utility-rates/`,
  getUtilityRatesByUtility: `${API_BASE_URL}/api/utility-rates/by-utility/`,
  getUtilityRatesByTerritory: `${API_BASE_URL}/api/utility-rates/by-territory/rates/`,
  getUtilityRateDetail: `${API_BASE_URL}/api/utility-rates/`,
  getUtilityRateUtilities: `${API_BASE_URL}/api/utility-rates/utilities/`,

  // DataHub
  dataHubOverview: `${API_BASE_URL}/api/overview/`,

  // Internal Ops
  internalOpsUsers: `${API_BASE_URL}/api/internal/users/`,
  internalOpsUser: (userId) => `${API_BASE_URL}/api/internal/users/${encodeURIComponent(userId)}/`,
  internalOpsApiUsage: `${API_BASE_URL}/api/internal/api-usage/`,
  internalOpsApiUsageApp: (appLabel) =>
    `${API_BASE_URL}/api/internal/api-usage/${encodeURIComponent(appLabel)}/`,
  internalOpsApiUsageEndpoint: (appLabel) =>
    `${API_BASE_URL}/api/internal/api-usage/${encodeURIComponent(appLabel)}/endpoint/`,
  internalOpsDatabase: `${API_BASE_URL}/api/internal/database/`,
  internalOpsDatabaseApp: (appLabel) => `${API_BASE_URL}/api/internal/database/${encodeURIComponent(appLabel)}/`,
  internalOpsDatabaseTable: (appLabel, modelName) =>
    `${API_BASE_URL}/api/internal/database/${encodeURIComponent(appLabel)}/${encodeURIComponent(modelName)}/`,
  internalOpsTraffic: `${API_BASE_URL}/api/internal/traffic/`,
  internalOpsLoginAreas: `${API_BASE_URL}/api/internal/login-areas/`,
  internalOpsParcelPopularity: `${API_BASE_URL}/api/internal/parcel-popularity/`,
  sitePageview: `${API_BASE_URL}/api/public/site-pageview/`,
  getUtilityTerritories: `${API_BASE_URL}/api/utility-service-territories/`,
  getUtilityTerritoryStates: `${API_BASE_URL}/api/utility-service-territories/states/`,
  getUtilityTerritoryDetail: `${API_BASE_URL}/api/utility-service-territories/`,
  getUtilityZctaOverlaps: `${API_BASE_URL}/api/utility-zcta-overlaps/`,
  getChargingStationsDOE: `${API_BASE_URL}/api/get-ev-charging-stations/`,
  getChargingStationsCalSTART: `${API_BASE_URL}/api/getallchargingstations/`,
  getChargingStationDOEDetail: `${API_BASE_URL}/api/get-ev-charging-station-detail/`,
  getVehicleModels: `${API_BASE_URL}/api/get-vehicle-data/`,

  // Regulator module (dev-only)
  uploadApplicantAddresses: `${API_BASE_URL}/api/regulator/upload-addresses/`,
  regulatorAddressImportTemplate: `${API_BASE_URL}/api/regulator/address-import-template/`,

  // Regulator module (locations-only API; dataset concept removed in backend)
  regulatorLocationsUpload: `${API_BASE_URL}/api/regulator/locations/upload/`,
  regulatorLocations: `${API_BASE_URL}/api/regulator/locations/`,
  regulatorProcess: `${API_BASE_URL}/api/regulator/locations/process/`,
  regulatorCancel: `${API_BASE_URL}/api/regulator/locations/cancel/`,
  regulatorStatus: `${API_BASE_URL}/api/regulator/locations/status/`,
  regulatorCircuitStaleness: `${API_BASE_URL}/api/regulator/locations/circuit-staleness/`,
  regulatorMetrics: `${API_BASE_URL}/api/regulator/metrics/`,
  regulatorCalEnviroScreen40: `${API_BASE_URL}/api/regulator/calenviroscreen-40/`,
  regulatorExportXlsx: `${API_BASE_URL}/api/regulator/locations/export/xlsx/`,

  // Backward-compat (deprecated): keep old keys in case some UI still references them
  regulatorDatasets: `${API_BASE_URL}/api/regulator/datasets/`,
  regulatorDatasetDetail: (id) => `${API_BASE_URL}/api/regulator/datasets/${id}/`,
  regulatorDatasetProcess: (id) => `${API_BASE_URL}/api/regulator/datasets/${id}/process/`,
  regulatorDatasetStatus: (id) => `${API_BASE_URL}/api/regulator/datasets/${id}/status/`,
  regulatorDatasetExportCsv: (id) => `${API_BASE_URL}/api/regulator/datasets/${id}/export/csv/`,
  regulatorDatasetExportXlsx: (id) => `${API_BASE_URL}/api/regulator/datasets/${id}/export/xlsx/`,
  regulatorDatasetLocations: (id) => `${API_BASE_URL}/api/regulator/datasets/${id}/locations/`,
  regulatorLocationDetail: (id) => `${API_BASE_URL}/api/regulator/locations/${id}/`,

  sageListings: `${API_BASE_URL}/api/sage/listings/`,
}; 